var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeedbackNav(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40.0026,
    height: 40.0026,
    rx: 10.6663,
    fill: "#E9ECEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1179 11.5143C19.4957 10.5736 20.8273 10.5736 21.2051 11.5143L22.8069 15.5031C22.9678 15.9037 23.3437 16.1769 23.7744 16.2061L28.063 16.4969C29.0744 16.5654 29.4859 17.8319 28.708 18.4819L25.4094 21.2379C25.0781 21.5147 24.9345 21.9567 25.0398 22.3753L26.0885 26.5438C26.3358 27.5269 25.2584 28.3096 24.3999 27.7706L20.7595 25.4851C20.3939 25.2556 19.9291 25.2556 19.5635 25.4851L15.9231 27.7706C15.0646 28.3096 13.9872 27.5269 14.2345 26.5438L15.2832 22.3753C15.3885 21.9567 15.2449 21.5147 14.9136 21.2379L11.615 18.4819C10.8371 17.8319 11.2486 16.5654 12.26 16.4969L16.5486 16.2061C16.9793 16.1769 17.3552 15.9037 17.5161 15.5031L19.1179 11.5143Z",
    stroke: "black",
    strokeWidth: 1.6869,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackNav);
export default __webpack_public_path__ + "static/media/feedback-nav.42d7b89ec5c178c73c29d1c14f8d42da.svg";
export { ForwardRef as ReactComponent };